<div class="p-fluid" style="text-align: center;">
  <div class="ui-g-12" style="display: flex; align-items: center; margin-top: -13%;">
    <img style="width: 6%; margin: 0 auto;" src="assets/images/telemedicina/copago.png">
  </div>
  <div class="ui-g-12"><h2 style="font-weight: 400; font-size: 38px; color: #073c8f; font-family: poppins;">Consulta de copago</h2></div>
  <div class="ui-g-12">
    <h3 style="font-family: poppins; font-weight: 300; text-align: center; font-size: 20px;">{{copaymentInfo["type"]}}</h3>
    <h2 style="font-weight: 800; color: #073c8f; font-size: 30px; font-family: poppins;">{{copaymentInfo["description"]}}</h2>
  </div>
  <div style="margin-top: 15%;">
    <h3 style="font-family: poppins; font-weight: 300; text-align: center; font-size: 20px;">¿Proceder con el pago?</h3>
  </div>
</div>
<div class="ui-g-12 ui-sm-12" style="text-align: center; margin-top: 2%;">
  <div class="ui-g-12 ui-sm-12 p-nogutter p-justify-end">
    <button pButton type="button" label="Siguiente" class="boton1 ui-button-primary ui-widget ui-state-default" icon="pi pi-angle-right" iconPos="right" (click)="nextPage()" style="width: 35%; font-weight: 800;"></button>
  </div>
</div>

